/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".timepicker-alignment[_ngcontent-%COMP%]{margin-top:3px;display:flex;justify-content:space-around;align-items:center}.edit-notification[_ngcontent-%COMP%]{width:100%;border-radius:4px;border:1px solid #d39e00;background-color:#ffc107;text-align:center;padding:8px;font-weight:700}.appendix-text[_ngcontent-%COMP%]{position:absolute;width:105px;top:65px;left:5px;text-decoration:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}button[_ngcontent-%COMP%]   span.is-fullwidth[_ngcontent-%COMP%]{padding-bottom:12px}"];
export { styles as styles };
